"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Instagram, MessageCircle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer id="footer" ref={footerRef} className="dark bg-background text-foreground py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {}
        <div className={`flex justify-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548683/img/lumiere_boutique_footer_logo.png" alt="LUMIÈRE Boutique" className="h-7" />
        </div>

        {}
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] delay-100 ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <div className="text-center md:text-left" data-index={0}>
            <h3 className="font-display text-lg mb-4 tracking-wide">
              Navegación
            </h3>
            <nav className="flex flex-col gap-3">
              <Link to="/ShopCollectionPage" className="text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                Colección
              </Link>
              <Link to="/AboutUsPage" className="text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                Sobre Nosotros
              </Link>
              <Link to="/LookbookPage" className="text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                Lookbook
              </Link>
              <Link to="/ContactPage" className="text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                Contacto
              </Link>
            </nav>
          </div>

          {}
          <div className="text-center md:text-left" data-index={1}>
            <h3 className="font-display text-lg mb-4 tracking-wide">Legal</h3>
            <nav className="flex flex-col gap-3">
              <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                Términos y Condiciones
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
                Política de Privacidad
              </Link>
            </nav>
          </div>

          {}
          <div className="text-center md:text-left" data-index={2}>
            <h3 className="font-display text-lg mb-4 tracking-wide">Social</h3>
            <div className="flex justify-center md:justify-start gap-4">
              <Link to="https://instagram.com" newTab className="text-accent hover:text-foreground transition-colors duration-[var(--duration-fast)]" aria-label="Instagram">
                <Instagram className="size-6" />
              </Link>
              <Link to="https://wa.me/5256789101" newTab className="text-accent hover:text-foreground transition-colors duration-[var(--duration-fast)]" aria-label="WhatsApp">
                <MessageCircle className="size-6" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <Separator className={`bg-accent mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] delay-200 ${footerVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"}`} />

        {}
        <div className={`text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] delay-300 ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <p className="text-xs text-muted-foreground tracking-widest uppercase">
            &copy; 2024 LUMIERE Boutique. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}